import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PracticeTestHeader.scss';

const PracticeTestHeader = ({ assessment }) => {
  const { t } = useTranslation('practice_tests');

  const getStatusMessage = () => {
    if (assessment.evaluation_status === 'PS') {
      return (
        <h2 style={{ margin: '35px auto', fontFamily: 'Roboto', fontSize: '22px' }}>
          {t('practice_tests.test_header.congratulations')}
        </h2>
      );
    } else if (assessment.evaluation_status === 'FL') {
      return (
        <h2 style={{ margin: '35px auto', fontFamily: 'Roboto', fontSize: '22px' }}>
          {t('practice_tests.test_header.good_attempt')}
        </h2>
      );
    }
    return null;
  };

  return (
    <div
      className={styles['c-practice-test-header']}
      data-test-id="practice-test-header"
      data-specific-id="practice-test-header-container"
    >
      {getStatusMessage()}
    </div>
  );
};

export default PracticeTestHeader;
